import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Rss } from "lucide-react";
import { Wordmark } from "@/components/site/Wordmark";
import { BEEHIIV_FORM_ID, LINKS } from "@/content/site";

export const SubscribePanel = ({ className = "", title = "Stay updated." }) => {
  const host = useRef(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const el = host.current;
    if (!el) return undefined;
    el.innerHTML = "";
    const script = document.createElement("script");
    script.src = "https://subscribe-forms.beehiiv.com/v3/loader.js";
    script.async = true;
    script.setAttribute("data-beehiiv-form", BEEHIIV_FORM_ID);
    el.appendChild(script);
    const timer = setTimeout(() => {
      if (!el.querySelector("iframe")) setFailed(true);
    }, 9000);
    return () => {
      clearTimeout(timer);
      el.innerHTML = "";
    };
  }, []);

  return (
    <div className={`rounded-3xl bg-white p-6 text-ink sm:p-8 ${className}`} data-testid="subscribe-panel">
      <div className="flex items-center justify-between">
        <span className="eyebrow text-[#4b5563]">The Logbook · Newsletter</span>
        <Wordmark size="text-lg" className="text-ink" />
      </div>
      <h3 className="mt-8 text-4xl font-[580] leading-[0.95] tracking-[-0.04em]">{title}</h3>
      <p className="mt-4 text-[15px] leading-relaxed text-[#374151]">
        Maritime technology and x1025's progress, written by Hash. In your inbox no more than once a week.
      </p>
      <div ref={host} className="-mx-4 mt-3 min-h-[200px]" data-testid="beehiiv-subscribe-embed" data-clarity-mask="true" />
      {failed && (
        <a href={`${LINKS.beehiiv}subscribe`} target="_blank" rel="noopener noreferrer" className="mt-2 flex items-center justify-center gap-2 rounded-full bg-ink py-3.5 text-[15px] font-[560] text-white" data-testid="subscribe-fallback-link" data-analytics-event="newsletter_opened">
          Subscribe on Beehiiv <ArrowUpRight className="h-4 w-4" />
        </a>
      )}
      <div className="mt-4 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-black/10 pt-4 text-[14px]">
        <Link to="/logbook" className="inline-flex items-center gap-1 font-[540] text-ink hover:underline" data-testid="subscribe-read-logbook">Read the Logbook <ArrowUpRight className="h-3.5 w-3.5" /></Link>
        <a href={LINKS.rss} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-[#374151] hover:text-ink" data-testid="subscribe-rss-link"><Rss className="h-3.5 w-3.5" /> RSS</a>
      </div>
    </div>
  );
};
